<template>
  <div class="field-group">
    <div v-for="(field, index) in modelValue" :key="index" class="dynamic-field-row">
      <div class="field dynamic-field-row__name">
        <label class="field__label">Kategorie-Merkmal<span class="required-mark">*</span></label>
        <input
          class="field__input"
          type="text"
          :value="field.name"
          @input="updateField(index, 'name', $event.target.value)"
        />
      </div>
      <div class="field dynamic-field-row__desc-field">
        <label class="field__label">Beschreibung</label>
        <div class="dynamic-field-row__desc">
          <textarea
            class="field__textarea"
            :value="field.description"
            @input="updateField(index, 'description', $event.target.value)"
          ></textarea>
          <button type="button" class="remove-field-btn" title="Feld entfernen" @click="removeField(index)">✕</button>
        </div>
      </div>
    </div>

    <button type="button" class="add-field-btn" @click="addField">+ Feld hinzufügen</button>
  </div>
</template>

<script>
export default {
  name: 'DynamicFieldList',
  props: {
    modelValue: { type: Array, default: () => [] },
  },
  emits: ['update:modelValue'],
  methods: {
    updateField(index, key, value) {
      const updated = this.modelValue.map((field, i) => (i === index ? { ...field, [key]: value } : field));
      this.$emit('update:modelValue', updated);
    },
    addField() {
      this.$emit('update:modelValue', [...this.modelValue, { name: '', description: '' }]);
    },
    removeField(index) {
      this.$emit('update:modelValue', this.modelValue.filter((_, i) => i !== index));
    },
  },
};
</script>

<style scoped src="../forms/form.css"></style>
<style scoped>
.dynamic-field-row {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 16px;
}

.dynamic-field-row__name {
  min-width: 0;
}

.dynamic-field-row__desc-field {
  min-width: 0;
}

.dynamic-field-row__desc {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.dynamic-field-row__desc .field__textarea {
  flex: 1;
  min-height: 90px;
  line-height: 1.5;
}

@media (max-width: 700px) {
  .dynamic-field-row {
    grid-template-columns: 1fr;
  }
}

.remove-field-btn {
  background: #fff5f5;
  border: 1px solid #f3b4b4;
  color: #c0121c;
  border-radius: 3px;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.remove-field-btn:hover {
  background: #fde2e2;
}

.add-field-btn {
  align-self: flex-start;
  background: #eef4fb;
  border: 1px solid #c3d9f0;
  color: #1e6eb5;
  padding: 9px 18px;
  border-radius: 3px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.add-field-btn:hover {
  background: #dbe9f7;
}
</style>
